var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 20.5309L2.54457 11.2754C1.34306 10.0739 0.741848 8.49862 0.741848 6.91333C0.741848 5.33433 1.34332 3.75248 2.54457 2.55123C3.74657 1.34923 5.33545 0.741848 6.91333 0.741848C8.49234 0.741848 10.0742 1.34332 11.2754 2.54457L11.7987 3.06784L12.3233 2.54586C13.5325 1.34263 15.1088 0.741848 16.6867 0.741848C18.2708 0.741848 19.8532 1.34897 21.0554 2.55123C22.263 3.75877 22.8582 5.33377 22.8582 6.91333C22.8582 8.49233 22.2567 10.0742 21.0554 11.2754L11.8 20.5309Z",
    fill: "#E7368B",
    stroke: "#E7368B",
    strokeWidth: 1.4837
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconFilled);
export default __webpack_public_path__ + "static/media/heart-icon-filled.eb910274a14013589807c7c7e62a0cdb.svg";
export { ForwardRef as ReactComponent };